export const SiteEvents = {
  cartUpdate: 'cart-update',
  cartDrawerToggle: 'cart-drawer-toggle',
  cartDrawerContentUpdate: 'cart-drawer-content-update',
  cartDrawerClose: 'cart-drawer-close',
  cartDrawerStateChange: 'cart-drawer-state-change',
  transitionStart: 'transition-start',
  transitionEnd: 'transition-end',
  enterAnimationStart: 'enter-animation-start',
}

/**
 * Event fired when the cart is updated
 * @extends {Event}
 */
export class CartUpdateEvent extends Event {
  constructor(cart) {
    super(CartUpdateEvent.eventName, { bubbles: true });
    this.cart = cart;
  }

  static eventName = SiteEvents.cartUpdate;
}

/**
 * Event fired when the cart content is updated
 * @extends {Event}
 */
export class CartContentUpdateEvent extends Event {
  constructor(html) {
    super(CartContentUpdateEvent.eventName, { bubbles: true });
    this.html = html;
  }

  static eventName = SiteEvents.cartContentUpdate;
}

/**
 * Event fired when the cart drawer is toggled
 * @extends {Event}
 */
export class CartDrawerToggleEvent extends Event {
  constructor(state) {
    super(CartDrawerToggleEvent.eventName, { bubbles: true });
    this.state = state;
  }

  static eventName = SiteEvents.cartDrawerToggle;
}

/**
 * Event fired when the cart drawer is closed
 * @extends {Event}
 */
export class CartDrawerCloseEvent extends Event {
  constructor() {
    super(CartDrawerCloseEvent.eventName, { bubbles: true });
  }

  static eventName = SiteEvents.cartDrawerClose;
}

/**
 * Event fired when the cart drawer state changes
 * @extends {Event}
 */
export class CartDrawerStateChangeEvent extends Event {
  constructor(open) {
    super(CartDrawerStateChangeEvent.eventName, { bubbles: true });
    this.open = open;
  }

  static eventName = SiteEvents.cartDrawerStateChange;
}

/**
 * Event fired when the transition starts
 * @extends {Event}
 */
export class TransitionStartEvent extends Event {
  constructor() {
    super(TransitionStartEvent.eventName, { bubbles: true });
  }

  static eventName = SiteEvents.transitionStart;
}

/**
 * Event fired when the transition ends
 * @extends {Event}
 */
export class TransitionEndEvent extends Event {
  constructor() {
    super(TransitionEndEvent.eventName, { bubbles: true });
  }

  static eventName = SiteEvents.transitionEnd;
}

/**
 * Event fired when the page changes
 * @extends {Event}
 */
export class EnterAnimationStartEvent extends Event {
  constructor() {
    super(EnterAnimationStartEvent.eventName, { bubbles: true });
  }
}